import { render, staticRenderFns } from "./ProposalDetails.vue?vue&type=template&id=4ac2bdc3&"
import script from "./ProposalDetails.vue?vue&type=script&lang=js&"
export * from "./ProposalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProposalDetails.vue?vue&type=style&index=0&id=4ac2bdc3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports